import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useOturum } from './lib/oturum'
import GirisSayfasi from './modules/auth/GirisSayfasi'
import CikisSayfasi from './modules/auth/CikisSayfasi'
import PanelSayfasi from './modules/dashboard/PanelSayfasi'
import StokKartlariSayfasi from './modules/masterdata/StokKartlariSayfasi'
import CarilerSayfasi from './modules/masterdata/CarilerSayfasi'
import HareketlerSayfasi from './modules/inventory/HareketlerSayfasi'
import MalKabulSayfasi from './modules/intake/MalKabulSayfasi'
import LaboratuvarSayfasi from './modules/lab/LaboratuvarSayfasi'
import UnitelerSayfasi from './modules/uretim/UnitelerSayfasi'
import BeyanSayfasi from './modules/declaration/BeyanSayfasi'
import BeslemeSayfasi from './modules/feeding/BeslemeSayfasi'
import FiloSayfasi from './modules/fleet/FiloSayfasi'
import ProfilSayfasi from './modules/account/ProfilSayfasi'
import AyarlarSayfasi from './modules/settings/AyarlarSayfasi'
import EntegrasyonSayfasi from './modules/entegrasyon/EntegrasyonSayfasi'
import EtiketlerSayfasi from './modules/entegrasyon/EtiketlerSayfasi'
import SirketlerSayfasi from './modules/sistem/SirketlerSayfasi'
import KutuphaneSayfasi from './modules/sistem/KutuphaneSayfasi'
import HesapSayfasi from './modules/sistem/HesapSayfasi'
import StyleguideSayfasi from './modules/styleguide/StyleguideSayfasi'
import './styles/design-system.css'
// Ekranların kendi ölçü farkları (.sf-NN) tabandan SONRA yüklenir.
import './styles/ekran-ustleri.css'
// Etkileşim durumları en SONA kalır ki :disabled kuralları kazansın.
import './styles/durumlar.css'

/** Oturum yoksa /giris'e atar; kullanıcı geldiği yeri kaybetmesin diye state'te taşır. */
function Korumali({ children }: { children: React.ReactNode }) {
  const { durum } = useOturum()
  const konum = useLocation()
  if (!durum) return <Navigate to="/giris" replace state={{ nereden: konum.pathname }} />

  // Süper adminin tesis kapsamı yok: tenant ekranları onun için boş/kırık
  // çalışır (izin haritası boş, tesis null). Adres çubuğuna elle yazsa bile
  // kendi paneline dönüyor. Asıl kapı SUNUCUDA — bu yalnız kolaylık.
  if (durum.kullanici.rol === 'sistem_yoneticisi') {
    return <Navigate to="/sistem" replace />
  }
  return <>{children}</>
}

/** Yalnız süper admin. Tenant kullanıcısı kendi paneline döner. */
function SistemKorumali({ children }: { children: React.ReactNode }) {
  const { durum } = useOturum()
  const konum = useLocation()
  if (!durum) return <Navigate to="/giris" replace state={{ nereden: konum.pathname }} />
  if (durum.kullanici.rol !== 'sistem_yoneticisi') return <Navigate to="/" replace />
  return <>{children}</>
}

export default function App() {
  return (
    <Routes>
      <Route path="/giris" element={<GirisSayfasi />} />
      <Route path="/cikis" element={<CikisSayfasi />} />

      {/* Sistem yönetimi — kendi kabuğu var, tenant menüsü taşımıyor. */}
      <Route
        path="/sistem"
        element={<SistemKorumali><SirketlerSayfasi /></SistemKorumali>}
      />
      <Route
        path="/sistem/kutuphane"
        element={<SistemKorumali><KutuphaneSayfasi /></SistemKorumali>}
      />
      <Route
        path="/sistem/hesap"
        element={<SistemKorumali><HesapSayfasi /></SistemKorumali>}
      />
      <Route
        path="/"
        element={
          <Korumali>
            <PanelSayfasi />
          </Korumali>
        }
      />
      <Route
        path="/stok-kartlari"
        element={<Korumali><StokKartlariSayfasi /></Korumali>}
      />
      <Route
        path="/cariler"
        element={<Korumali><CarilerSayfasi /></Korumali>}
      />
      <Route
        path="/stok-hareketleri"
        element={<Korumali><HareketlerSayfasi /></Korumali>}
      />
      <Route
        path="/mal-kabul"
        element={<Korumali><MalKabulSayfasi /></Korumali>}
      />
      <Route
        path="/laboratuvar"
        element={<Korumali><LaboratuvarSayfasi /></Korumali>}
      />
      <Route
        path="/uniteler"
        element={<Korumali><UnitelerSayfasi /></Korumali>}
      />
      {/* Referans ekranı olmayan yeni modül — ekran sınıfı (.sf-NN) yok,
          tabana düşüyor (bkz. styles/parite.test.ts KAPSAM_DISI). */}
      <Route
        path="/entegrasyon"
        element={<Korumali><EntegrasyonSayfasi /></Korumali>}
      />
      {/* Aynı modülün ikinci görünümü: kurulum ağacı yerine akan etiketlerin
          tamamı + zaman serisi. Ayrı rota, çünkü adres paylaşılabilir olmalı. */}
      <Route
        path="/entegrasyon/etiketler"
        element={<Korumali><EtiketlerSayfasi /></Korumali>}
      />
      <Route
        path="/uretim-beyani"
        element={<Korumali><BeyanSayfasi /></Korumali>}
      />
      <Route
        path="/besleme"
        element={<Korumali><BeslemeSayfasi /></Korumali>}
      />
      <Route
        path="/filo"
        element={<Korumali><FiloSayfasi /></Korumali>}
      />
      {/* Profil izin gerektirmez — herkes kendi kaydını görür (ekran 13). */}
      <Route
        path="/profil"
        element={<Korumali><ProfilSayfasi /></Korumali>}
      />
      <Route
        path="/ayarlar"
        element={<Korumali><AyarlarSayfasi /></Korumali>}
      />
      {/* §3.1: styleguide YALNIZ dev build'de. Üretim paketinde rota hiç
          tanımlanmıyor — gizlenmiş değil, yok. */}
      {import.meta.env.DEV && (
        <Route
          path="/styleguide"
          element={<Korumali><StyleguideSayfasi /></Korumali>}
        />
      )}
      {/* Yetki kapısı sayfanın İÇİNDE — kabuk (menü, tesis, kullanıcı) görünür
          kalsın ki kullanıcı nereye düştüğünü anlasın ve başka modüle geçebilsin. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
